import React from 'react';
import ReactDOM from 'react-dom/client';
import config from './Config';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom'; 

const root = ReactDOM.createRoot(document.getElementById('root'));

window.modals = [];

window.AppRef = new React.createRef();
window.SignInRef = new React.createRef();
window.AppHeaderRef = new React.createRef();
window.AppFooterMenuRef = new React.createRef();

//itt fontos a sorrend mert a visszagomb megnyomására mindig az itt leírt sorrendben az első látható modalt zárjuk be

window.modals.CheckoutDeliveryRef = new React.createRef(); // Átvétel
window.modals.CheckoutPaymentRef = new React.createRef(); // Fizetés
window.modals.CheckoutBillRef = new React.createRef(); // Számlázási adatok
window.modals.CheckoutSummaryRef = new React.createRef(); // Megrendelés összesítő
window.modals.PopupAddedToCartRef = new React.createRef();
window.modals.PopupContentRef = new React.createRef();
window.modals.PopupRateAppRef = new React.createRef();
window.modals.ShoppingCartRef = new React.createRef();
window.modals.ProductsMenuRef = new React.createRef();
window.modals.MyOrdersRef = new React.createRef();
window.modals.MyOrdersRef_2 = new React.createRef();
window.modals.MyMessagesRef = new React.createRef(); 
window.modals.MyMessagesRef_2 = new React.createRef(); 
window.modals.ProfileMenuRef = new React.createRef();
window.modals.WishlistRef = new React.createRef();
window.modals.RoyaltyCardRef = new React.createRef();
window.modals.AppDiscountsRef = new React.createRef();
window.modals.AppDiscountsRef_2 = new React.createRef();
window.modals.ProfileBillAddressRef = new React.createRef();
window.modals.ProfileTVKRef = new React.createRef();
window.modals.ProfileDeliveryAddressesRef = new React.createRef();
window.modals.ProfileRef = new React.createRef();
window.modals.ShopsRef = new React.createRef();

//window.modals.ProfilePaymentMethodRef = new React.createRef();

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App ref={window.AppRef} />
    </BrowserRouter>
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register(config);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
